import { useEffect, useState } from 'react'

import type { DocumentPreviewInput } from '@snootsvet/shared'

import { useOsApi } from '@/frontend/hooks/api/use-os-api'

type PreviewDocument = DocumentPreviewInput & { url: string }

export function usePreviewDocument() {
  const api = useOsApi()
  const [preview, setPreview] = useState<PreviewDocument | null>(null)

  useEffect(() => {
    if (!preview) return
    return () => URL.revokeObjectURL(preview.url)
  }, [preview])

  async function previewDocument(request: DocumentPreviewInput) {
    const result = await api.post('/documents/:documentType/preview', {
      params: { documentType: request.documentType },
      body: request.input,
    })
    if (result.success) setPreview({ ...request, url: URL.createObjectURL(result.data) })
    return result
  }

  return { clearPreview: () => setPreview(null), preview, previewDocument }
}
